import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  clientId: yup.number().required(),
});

export function useChangePatientAccessStatusMutation({
  onSuccess,
  onError,
  onMutate,
  onSettled,
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto) => {
      const req = requestSchema.validateSync(dto, { strict: true });
      return http.put(HTTP_ENDPOINTS.patient.updateAccess(req.clientId));
    },
    onMutate: () => {
      onMutate?.();
    },
    onSettled: () => {
      onSettled?.();
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.client],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.clients],
      });
      onSuccess?.(...args);
    },
    onError: (...args) => {
      onError?.(...args);
    },
  });
}
